import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addReason,
  deleteReason,
  getAllReasons,
  getReasons,
  updateReason,
} from "store/services/dataManagement/activityReason";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetAllReasonsAction = createAsyncThunk(
  "reason/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getReasons(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// In store/middlewares/dataManagement/activityReason.js
export const GetAllReasonsForSelectAction = createAsyncThunk(
  "reason/getAll",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getAllReasons(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const AddReasonAction = createAsyncThunk(
  "reason/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, onError, filter, ...data } = payload;
      const res = await addReason(data);
      if (res.status === 1) {
        if (onSuccess) onSuccess();
        dispatch(closeAdminModal());
        const listRes = await getReasons(filter);
        if (listRes.status === 1) {
          return fulfillWithValue(listRes);
        }
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const UpdateReasonAction = createAsyncThunk(
  "reason/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, onError, filter, ...data } = payload;
      const res = await updateReason(data);
      if (res.status === 1) {
        if (onSuccess) onSuccess();
        dispatch(closeAdminModal());
        const listRes = await getReasons(filter);
        if (listRes.status === 1) {
          return fulfillWithValue(listRes);
        }
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const DeleteReasonAction = createAsyncThunk(
  "reason/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, onError, filter, id } = payload;
      const res = await deleteReason(id);
      if (res.status === 1) {
        if (filter) {
          const listRes = await getReasons(filter);
          if (listRes.status === 1) {
            if (onSuccess) onSuccess();
            return fulfillWithValue(listRes);
          }
        }
        if (onSuccess) onSuccess();
        return fulfillWithValue(res);
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
